import { injectable } from 'inversify';
import env from '@/Framework/env/env';

export interface IDomainConfig {
  scheme: string,
  protocol: string,
  globalDomain: string,
  creditflowresearchDomain: string,
  apiSubdomain: string,
  socketSubdomain: string,
  usersSubdomain: string,
  drsSubdomain: string,
  dmPortalSubdomain: string,
  condorSubdomain: string,
  openmarketSubdomain: string,
  drsLegacyDomain: string,
  assetsSubdomain: string,
  evercallDomain: string,
  corsDomains: string,
  allocateSubdomain: string,
}

@injectable()
export class DomainConfig implements IDomainConfig {
  scheme: string;

  protocol: string;

  globalDomain: string;

  creditflowresearchDomain: string;

  apiSubdomain: string;

  socketSubdomain: string;

  usersSubdomain: string;

  drsSubdomain: string;

  dmPortalSubdomain: string;

  condorSubdomain: string;

  openmarketSubdomain: string;

  drsLegacyDomain: string;

  assetsSubdomain: string;

  evercallDomain: string;

  corsDomains: string;

  allocateSubdomain: string;

  constructor() {
    this.scheme = env('DOMAIN__SCHEME');
    this.protocol = `${ this.scheme } :`;
    this.globalDomain = env('DOMAIN__GLOBAL');
    this.creditflowresearchDomain = env('DOMAIN__CREDITFLOWRESEARCH');
    this.apiSubdomain = env('DOMAIN__SUBDOMAIN_API');
    this.socketSubdomain = env('DOMAIN__SUBDOMAIN_SOCKET');
    this.usersSubdomain = env('DOMAIN__SUBDOMAIN_USERS');
    this.drsSubdomain = env('DOMAIN__SUBDOMAIN_DEALROADSHOW');
    this.dmPortalSubdomain = env('DOMAIN__SUBDOMAIN_DM_PORTAL');
    this.condorSubdomain = env('DOMAIN__SUBDOMAIN_CONDOR');
    this.openmarketSubdomain = env('DOMAIN__SUBDOMAIN_OPENMARKET');
    this.drsLegacyDomain = env('DOMAIN__DRS_LEGACY_DOMAIN') || 'dealroadshow.com';
    this.assetsSubdomain = env('DOMAIN__SUBDOMAIN_ASSETS');
    this.evercallDomain = env('EVERCALL__DOMAIN');
    this.corsDomains = env('DOMAIN__CORS_DOMAINS');
    this.allocateSubdomain = env('DOMAIN__SUBDOMAIN_ALLOCATE');
  }
}
